import classNames from "classnames";
import scaredAmicon from "assets/images/illustrations/error.png";
import { Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";

const Error = ({ className, children = null, error = null }) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(className)}>
      <div className="ht-100 mt-5">
        {error ? (
          <>
            <Row className="justify-content-center">
              <Col md={8} sm={11}>
                <h3 className="text-center mx-3">
                  {t("Something went wrong")}
                </h3>
                <div className="text-center mx-3">
                  {t(
                    "Please try again or contact support if the problem persists."
                  )}
                </div>
                <img
                  src={scaredAmicon}
                  className="img-fluid mx-auto d-block"
                  alt="error"
                />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={8} sm={11}>
                <div className="alert bg-black text-white mx-3 mt-2 ">
                  <strong className="letter-capitalise">
                    {t("Error Logs")}
                  </strong>
                  <blockquote class="blockquote mt-3">
                    {error?.message}
                  </blockquote>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <i className="mdi mdi-alert-outline d-block display-4 align-items-center justify-content-center text-center  text-warning" />
            <div className="text-warning">{t("Something went wrong")}</div>
          </>
        )}

        {children}
      </div>
    </div>
  );
};

export default Error;
